import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/pt';
import {DEFAULT_LANGUAGE, normalizeLanguage, supportedLanguageCodes} from './utils';

import pt from './locales/pt.json';
import en from './locales/en.json';

const resources = {
   pt, en
}

i18n
.use(LanguageDetector)
.use(initReactI18next)
.init({
   resources,
   debug: true,
   fallbackLng: DEFAULT_LANGUAGE,
   supportedLngs: supportedLanguageCodes,
   nonExplicitSupportedLngs: true,
   load: 'languageOnly',
   detection: {
      // check browser/navigator first, then localStorage — never get stuck on a cached value
      order: ['navigator', 'localStorage', 'htmlTag'],
      caches: ['localStorage'],
      convertDetectedLanguage: normalizeLanguage,
   },
});

i18n.on('languageChanged', (lng) => {
   moment.locale(normalizeLanguage(lng));
});

moment.locale(normalizeLanguage(i18n.resolvedLanguage || i18n.language));

export default i18n;
